/**
 * @description 預定單
 * @param {String} uuid 用戶ID
 * @param {String} avatarImageUrl 用戶頭像
 * @param {String} nickname 用戶暱稱
 * @param {String} gameName 技能名稱
 * @param {Number} count 購買數量
 * @param {String} currencyKind 貨幣單位
 * @param {Number} salesPrice 單價
 * @param {String} salesUnit 計價單位
 * @param {String} playerSkillId 技能ID
 */
import * as $http from '@/axios'

const state = {
  preOrderInfo: null,
  // 評價後的禮物信息
  commentGiftInfo: null
}
const mutations = {
  CREATE_PRE_ORDER(state, orderInfo) {
    state.preOrderInfo = orderInfo
  },
  SET_COMMENT_GIFT_INFO(state, commentGiftInfo) {
    state.commentGiftInfo = commentGiftInfo
  }
}

let getGiftPromise = null

const actions = {
  preOrder({ commit }, payload) {
    commit('CREATE_PRE_ORDER', payload)
  },
  getGiftInfo({ commit, state }) {
    if (state.commentGiftInfo) return Promise.resolve(state.commentGiftInfo)
    if (!getGiftPromise) {
      getGiftPromise = {}
      getGiftPromise.promise = new Promise((resolve) => {
        getGiftPromise.resolve = resolve
      })
    } else {
      return getGiftPromise.promise
    }
    $http.get('/gift/afterOrder')
      .then(({
        data
      }) => {
        commit('SET_COMMENT_GIFT_INFO', data)
        getGiftPromise.resolve(data)
      })
    return getGiftPromise.promise
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}